const initialState = {
    data: [],
  };
  
  const bankiReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'SET_BANKI':
        return { ...state, data: action.payload };
      default:
        return state;
    }
  };
  
  export default bankiReducer;